import { ManageAreaPresenter } from "@/app/ui/presenters/ManageAreaPresenter";
import { container } from "tsyringe";
import { ManageAreaApiRepository } from "../../repositories/api/ManageAreaApiRepository";
import ApiService from "../../services/ApiService";
import { ManageAreaMapper } from "@/data/persistences/mappers/ManageAreaMapper";
import { ManageAreaEndpoint } from "../../endpoints/ManageAreaEndpoint";

export class ManageAreaComponent {
  public static init() {
    container.register<ManageAreaApiRepository>(ManageAreaApiRepository, {
      useFactory: (d) => {
        return new ManageAreaApiRepository(
          d.resolve(ApiService),
          d.resolve(ManageAreaMapper),
          d.resolve(ManageAreaEndpoint)
        );
      }
    });
    container.register<ManageAreaMapper>(ManageAreaMapper, {
      useClass: ManageAreaMapper
    });
    container.register<ManageAreaPresenter>(ManageAreaPresenter, {
      useFactory: (d) => {
        return new ManageAreaPresenter(d.resolve(ManageAreaApiRepository));
      }
    });
  }
}
